import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <section {...{
      "className": "section-lead"
    }}><p parentName="section">{`Sets the country of the cart. When the country is set, the `}<a parentName="p" {...{
          "href": "/api/../api/projects/carts#lineitem"
        }}>{`LineItem`}</a>{` prices are updated.`}</p>
      <ul parentName="section">
        <li parentName="ul"><inlineCode parentName="li">{`action`}</inlineCode>{` - String - `}<inlineCode parentName="li">{`"setCountry"`}</inlineCode></li>
        <li parentName="ul"><inlineCode parentName="li">{`country`}</inlineCode>{` - String - Optional`}<br parentName="li"></br>
          {`A two-digit country code as per `}<a parentName="li" {...{
            "href": "https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2"
          }}>{`ISO 3166-1 alpha-2`}</a>{`.`}</li>
      </ul>
    </section>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      